import { React, useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Notification from "../components/Notification";
import useFetch from "../services/employeeService";
import axios from "axios";
import { useHistory, Redirect } from "react-router-dom";
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © AGCO"}
      <Link color="inherit" href="https://agcolk.com/"></Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignIn(props) {
  const classes = useStyles();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const [data, setData] = useState([["Loading..."]]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const history = useHistory();
  useEffect(() => {
    if (localStorage.getItem("authToken")) {
      history.push("/");
    }
  }, [history]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    // if (validateOnChange)
    //     validate({ [name]: value })
  };
  const handleSubmit = async function (e) {
    e.preventDefault();
    // if (validate()) {
    //   addOrEdit(values, resetForm);
    // }
    const abortController = new AbortController();

    // CORS for Deployment
    // axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
    await axios({
      method: "post",
      url: "https://api.agcolk.com/auth/login",
      // url: "http://localhost:3000/auth/login",
      signal: abortController.signal,
      data: { email: values.email, password: values.password },
    })
      .then((res) => {
        // console.log(res.data);
        setIsLoading(false);
        setData(res.data);
        setData((state) => {
          // console.log(JSON.stringify(state));
          localStorage.setItem("authToken", state.token);
          localStorage.setItem("currentUser", JSON.stringify(state));
          return state;
        });
        // console.log(data, isLoading);
        setError(null);

        history.push("/");
      })
      .catch((err) => {
        // console.log(err);
        if (err.name !== "AbortError") {
          // auto catches network / connection error
          setIsLoading(false);
          setError(err.message);
          // console.log(err.message);
          setNotify({
            isOpen: true,
            message: err.message,
            severity: "error",
            title: "Error",
          });
        }
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            value={values.email}
            onChange={handleInputChange}
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            value={values.password}
            onChange={handleInputChange}
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          {/* <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          /> */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
          {/* <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
      <Notification notify={notify} setNotify={setNotify} />
    </Container>
  );
}
